import { apiCall, apiCallAdmin } from "../../services/api-service";


export const getFAQListApi = async () => {
  const response = await apiCallAdmin("GET", "help?application=Dock");
  return response.data;
};


export const reportAnIssueApi = async (data) => {
  const response = await apiCallAdmin("POST", "report_issue", data);
  return response;
};


export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("GET", "get_issue_type");
  return response.data;
};

export const getProfileDetailsApi = async () => {
  const response = await apiCallAdmin("GET", "basicprofile", null, {
    params: {},
  });
  return response;
};

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("GET", "get_org_image");
  return response.data;
};

export const getAvailableDocksApi = async () => {
  const response = await apiCall("GET", "dock/dockmaster");
  return response;
};




export const getLocationFreeDocksApi = async () => {
  const response = await apiCall("GET", "dashboard/freedocks?search=");
  return response;
};

export const getLiveMonitorApi = async () => {
  const response = await apiCall("GET", "dashboard/livemonitor");
  return response;
};

export const getTimingListApi = async () => {
  const response = await apiCall("GET", "dashboard/timings");
  return response;
};
export const locationBasedDockOutDockInApi = async (month) => {
  const response = await apiCall(
    "POST",
    `dashboard/location_in_out?period=${month}&search=`,
    {},
  );
  return response;
};

export const sendOTPApi = async (data) => {
  const response = await apiCall("POST", "sent_otp", data);
  return response.data;
};

export const verifyOTPApi = async (data) => {
  const response = await apiCall("POST", "verify_otp", data);
  return response.data;
};


//  Dashboard count api
export const getCountApi = async () => {
  const response = await apiCall("GET", "signagedashboard/count");
  return response;
};

// External Overview API
export const getExternalOverviewApi = async () => {
  const response = await apiCall("GET", "signagedashboard/external_overview");
  return response;
};
// Status Overview API
export const getStatusOverviewApi = async () => {
  const response = await apiCall("GET", "signagedashboard/device_status_overview");
  return response;
};